<template>
  <label
    class="text-white rounded-full px-4 mb-0 tracking-wide font-medium uppercase"
    :class="['py-0.5', currentBgColor, `text-${fontSize}`]"
    type="badge"
  >
    <template v-if="value == 'public'">Public</template>
    <template v-else-if="value == 'private'">Private</template>
    <template v-else-if="value == 'selected'">Secure</template>
  </label>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

const props = defineProps({
  value: {
    type: String as PropType<'public' | 'private' | 'selected'>,
    required: true,
  },
  fontSize: {
    type: String,
    default: 'xs',
  },
})

const currentBgColor = computed(
  () =>
    ({
      public: 'bg-copper-800',
      private: 'bg-gold-900',
      selected: 'bg-blue-800',
    }[props.value])
)
</script>
